export default __webpack_public_path__ + "static/chatGPT-datas-0b90ed39d3bf3c38f98b901bc35bdcbe.webp";